import { Routes } from '@angular/router';
import { IndexComponent } from './app/pages/index/index.component';
import { LoginComponent } from './app/pages/login/login.component';
import { NotFoundComponent } from './app/pages/notfound/notfound.component';
import { AuthGuard } from './app/helper/guards/auth.guard';

export const appRoutes: Routes = [
    {
        path: '',
        component: IndexComponent,
        data: { title: 'footer.title' }
    },

    {
        path: 'login',
        component: LoginComponent,
        data: { title: 'auth.login' }
    },

    {
        path: 'app',
        loadChildren: () => import('./app/modules/product/product.routes'),
        canActivate: [AuthGuard]
    },
    {
        path: 'notfound',
        component: NotFoundComponent,
        data: { title: 'common.pageNotFound' }
    },
    { path: '**', redirectTo: '/notfound' }
];
